/**
 * Whether an Enter keypress in the composer should SEND the message.
 *
 * It should not when the suggestion list has a highlighted option — the user
 * arrowed onto an agent or skill and Enter means "pick that one". The composer
 * previously sent unconditionally, so `@` + Down + Enter fired off a message
 * containing a bare "@" instead of selecting the agent. The same was true of
 * `/` skills; the key handler simply had no idea a popup was open.
 *
 * `aria-activedescendant` is MUI Autocomplete's own signal that an option is
 * active, set on the input element. Using it keeps popup state out of the
 * composer, and it is absent when the list is merely open with nothing
 * highlighted — where Enter should still send.
 */
export function enterShouldSend(event: {
  key: string;
  shiftKey: boolean;
  target: EventTarget | null;
}): boolean {
  if (event.key !== "Enter" || event.shiftKey) return false;
  const field = event.target as HTMLElement | null;
  const active = field?.getAttribute?.("aria-activedescendant");
  return !active;
}
